import { END_OF_LIFE_DEFAULT_GROUP_BY } from "./components/charts/groupedAssetChart";
import { HORIZONTAL_DEFAULT_GROUP_BY, HORIZONTAL_DEFAULT_SORT, HORIZONTAL_DEFAULT_TYPE } from "./components/charts/horizontalAssetChart";

// //Update  Entity Param
export const UPDATE_ASSET_MANAGEMENT_ENTITY_PARAMS_SUCCESS = "UPDATE_ASSET_MANAGEMENT_ENTITY_PARAMS_SUCCESS";
export const UPDATE_ASSET_MANAGEMENT_ENTITY_PARAMS_FAILURE = "UPDATE_ASSET_MANAGEMENT_ENTITY_PARAMS_FAILURE";

// Get chart data
export const GET_CHARTS_DETAILS_REQUEST = "GET_CHARTS_DETAILS_REQUEST";
export const GET_CHARTS_DETAILS_SUCCESS = "GET_CHARTS_DETAILS_SUCCESS";
export const GET_CHARTS_DETAILS_FAILURE = "GET_CHARTS_DETAILS_FAILURE";

export const GET_FILTER_LISTS_REQUEST = "GET_CHART_MASTER_FILTER_LISTS_REQUEST";
export const GET_FILTER_LISTS_SUCCESS = "GET_CHART_MASTER_FILTER_LISTS_SUCCESS";
export const GET_FILTER_LISTS_FAILURE = "GET_CHART_MASTER_FILTER_LISTS_FAILURE";

export const SAVE_CHART_POPUP = "SAVE_CHART_POPUP";
export const SAVE_CHART_VIEW = "SAVE_CHART_VIEW";
export const SAVE_CHART_TAB = "SAVE_CHART_TAB";
export const SAVE_CHART_PARAMS = "SAVE_CHART_PARAMS";
export const SAVE_SELECTED_MASTER_FILTER_LIST = "SAVE_SELECTED_MASTER_FILTER_LIST";
//get fcicharts
export const GET_SFCI_CHART_REQUEST = "GET_SFCI_CHART_REQUEST";
export const GET_SFCI_CHART_SUCCESS = "GET_SFCI_CHART_SUCCESS";
export const GET_SFCI_CHART_FAILURE = "GET_SFCI_CHART_FAILURE";
//Get SFCI chart Data

export const GET_WEIGHTED_AVERAGE_CHART_REQUEST = "GET_WEIGHTED_AVERAGE_CHART_REQUEST";
export const GET_WEIGHTED_AVERAGE_CHART_SUCCESS = "GET_WEIGHTED_AVERAGE_CHART_SUCCESS";
export const GET_WEIGHTED_AVERAGE_CHART_FAILURE = "GET_WEIGHTED_AVERAGE_CHART_FAILURE";

export const GET_ASSET_DASHBOARD_MAP_REQUEST = "GET_ASSET_DASHBOARD_MAP_REQUEST";
export const GET_ASSET_DASHBOARD_MAP_SUCCESS = "GET_ASSET_DASHBOARD_MAP_SUCCESS";
export const GET_ASSET_DASHBOARD_MAP_FAILURE = "GET_ASSET_DASHBOARD_MAP_FAILURE";

export const GET_ASSET_IMPORT_HISTORY_REQUEST = "GET_ASSET_IMPORT_HISTORY_REQUEST";
export const GET_ASSET_IMPORT_HISTORY_SUCCESS = "GET_ASSET_IMPORT_HISTORY_SUCCESS";
export const GET_ASSET_IMPORT_HISTORY_FAILURE = "GET_ASSET_IMPORT_HISTORY_FAILURE";

export const DELETE_ASSET_IMPORT_HISTORY_REQUEST = "DELETE_ASSET_IMPORT_HISTORY_REQUEST";
export const DELETE_ASSET_IMPORT_HISTORY_SUCCESS = "DELETE_ASSET_IMPORT_HISTORY_SUCCESS";
export const DELETE_ASSET_IMPORT_HISTORY_FAILURE = "DELETE_ASSET_IMPORT_HISTORY_FAILURE";

export const GET_ASSET_GAUGE_CHART_REQUEST = "GET_ASSET_GAUGE_CHART_REQUEST";
export const GET_ASSET_GAUGE_CHART_SUCCESS = "GET_ASSET_GAUGE_CHART_SUCCESS";
export const GET_ASSET_GAUGE_CHART_FAILURE = "GET_ASSET_GAUGE_CHART_FAILURE";
export const DEFAULT_CHART_PARAMS = {
    sfci_chart_sort_by: "value",
    sfci_chart_sort_order: "desc",
    end_of_life_group_by: END_OF_LIFE_DEFAULT_GROUP_BY,
    horizontal_chart_type: HORIZONTAL_DEFAULT_TYPE,
    horizontal_group_by: HORIZONTAL_DEFAULT_GROUP_BY,
    horizontal_chart_sort_by: HORIZONTAL_DEFAULT_SORT.sortBy,
    horizontal_chart_sort_order: HORIZONTAL_DEFAULT_SORT.sortOrder,
    filters: null,
    list: null,
    has_image: null,
    verified_survey: null
};

export const DEFAULT_CHART_VIEW = {
    End_Of_Life_By_Year: "column",
    Horizontal_Chart: "bar",
    SFCI: "bar"
};
